export function parseDcfTagString(value: string | null | undefined): string[] {
  if (!value?.trim()) {
    return [];
  }

  return value
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);
}

export function joinDcfTagArray(tags: string[]): string {
  return tags.filter(Boolean).join(',');
}

export function buildDcfTagOptions(values: string[]): string[] {
  const seen = new Set<string>();

  values.forEach((value) => {
    const normalized = value.trim();
    if (normalized) {
      seen.add(normalized);
    }
  });

  return [...seen];
}
